import { Component, Prop, h } from '@stencil/core';
import { addClass } from '../../utils/helpers/helpers';

export type HeadingSize = 'xx-large' | 'x-large' | 'large' | 'medium' | 'small' | 'x-small';

@Component({
  tag: 'lgr-heading',
  styleUrl: 'heading.scss',
  shadow: true,
})
export class Heading {
  /**
   * size: the size of the font.
   */
  @Prop({ reflect: true }) size: HeadingSize = 'xx-large';
  /**
   * variant: inverse or not.
   */
  @Prop({ reflect: true }) inverse?: boolean;
  /**
   * dark: color black
   */
  @Prop() dark?: boolean;

  private headingSizeMap: { [size in HeadingSize]: string } = {
    'xx-large': 'h1',
    'x-large': 'h2',
    'large': 'h3',
    'medium': 'h4',
    'small': 'h5',
    'x-small': 'h6',
  };

  render() {
    const HeadingTag = this.headingSizeMap[this.size];

    return (
      <HeadingTag class={`${addClass([this.inverse ? 'inverse' : null, this.dark ? 'dark' : null])}`}>
        <slot></slot>
      </HeadingTag>
    );
  }
}
